module.exports = __webpack_public_path__ + "assets/star.8fac7e58.svg";